import React, { Component } from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import { LinkContainer } from 'react-router-bootstrap'
import './Navbar.css'
import {authProvider, db} from '../firebase'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

class MyNavbar extends Component{
    state = {
        user: null,
        name: null,
        show: false
    }
    componentDidMount(){
        authProvider.onAuthStateChanged((user) => {
            if(user){
                this.setState({user : user.uid})
                db.collection('users').get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // eslint-disable-next-line
                        if(doc.data().userId == this.state.user){
                            this.setState({
                                name: doc.data().name
                            })
                        }
                    })
                })
            }            
        })
    }
    clickHandler = (evt) => {
        this.setState({show: !this.state.show})
    }
    logout = () => {
        authProvider.signOut().then(() => {
            window.location.href = "/"       
        })
    }
    render() {
        return (
                <Navbar fixed="top" className="Navbar" >
                        <Nav className="mr-auto">
                            <LinkContainer exact to="/"><Nav.Link>Think Beyond</Nav.Link></LinkContainer>
                        </Nav>
                        <Nav className="ml-auto">
                            <LinkContainer className="d-none d-sm-block" exact to="/about"><Nav.Link>About</Nav.Link></LinkContainer>
                            <LinkContainer className="d-none d-sm-block" exact to="/contact"><Nav.Link>Contact</Nav.Link></LinkContainer>
                            <LinkContainer exact to="/shop"><Nav.Link>Shop</Nav.Link></LinkContainer>
                            { this.state.user ? <Nav.Link onClick={this.clickHandler}>{this.state.name}</Nav.Link> : 
                                <LinkContainer exact to="/login"><Nav.Link>Login</Nav.Link></LinkContainer>
                            }
                        </Nav>
                        <Modal
                            show={this.state.show}
                            onHide={this.clickHandler}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Log Out</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Do you wish to logout?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={this.clickHandler}>
                                    Cancel
                                </Button>
                                <Button variant="primary" onClick={this.logout}>Logout</Button>
                            </Modal.Footer>
                        </Modal>
                </Navbar>
        )
    }
}

export default MyNavbar